import React, { useEffect } from 'react';
import { Page } from '@bcm-dev/bcms-vite';


export default function PageContainer(props) {
  const className = props.className ?? "";
 // The ".page-sub-header" is set to a css "sticky" top position of 75px by default.
  // Adjust the position here depending on branding for integration.
  useEffect(() => {

    try{
      if(window.parent){
        if(window.parent.document){
          if(window.parent.document.loadFrame){
        
          window.parent.document.loadFrame();
        }
      }
      }
    }
   catch (error) {
  
   }
  });
 
  return(
    <Page className={className + " page-container"} isActive="false">
      {props.children}
    </Page>
  );
}